import * as React from "react";

import { SignOut20Regular } from "@fluentui/react-icons";
import { Avatar, Body1Strong, Button, Caption1, makeStyles, mergeClasses, tokens } from "@fluentui/react-components";

import { useAuth } from "@features/auth";

import { usePageContainerStyles } from "@shared/ui/pageContainer";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  info: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flexGrow: 1,
  },
  ellipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  email: {
    color: tokens.colorNeutralForeground3,
  },
  logoutButton: {
    flex: "none",
  },
});

const AppHeader: React.FC = () => {
  const styles = useStyles();
  const pageContainerStyles = usePageContainerStyles();
  const { profile, logout } = useAuth();

  if (!profile) {
    return null;
  }

  const fullName = `${profile.firstName} ${profile.lastName}`.trim() || profile.email;

  return (
    <div className={mergeClasses(pageContainerStyles.root, styles.root)}>
      <Avatar name={fullName} color="brand" />
      <div className={styles.info}>
        <Body1Strong className={styles.ellipsis}>{fullName}</Body1Strong>
        <Caption1 className={mergeClasses(styles.ellipsis, styles.email)}>{profile.email}</Caption1>
      </div>
      <Button className={styles.logoutButton} appearance="subtle" icon={<SignOut20Regular />} onClick={() => logout()}>
        Log out
      </Button>
    </div>
  );
};

export default AppHeader;
